<template>
<div class="ymda-time-select-container">
  <el-select class="time-selects" v-model="timeType" @change="reset">
    <el-option label="年" value="year" v-if="queryType === 'lp'"></el-option>
    <el-option label="月" value="month"></el-option>
    <el-option label="日" value="day"></el-option>
    <!-- <el-option label="任意" value="any"></el-option> -->
  </el-select>
  <component :is="timeType" v-model="date" @input="emit" v-if="timeType !== 'any'"></component>
  <template v-if="timeType === 'any'">
    <any v-model="anyData" @input="emitAny"></any>
    <timeResolution v-model="anyTimeResolution"></timeResolution>
  </template>
</div>
</template>

<script>
import year from './timeSelector/yearSelector.vue'
import month from './timeSelector/monthSelector.vue'
import day from './timeSelector/daySelector.vue'
import any from '@/components/TimeRangeSelect'
import timeResolution from '@/components/TimeResolutionSelect'
const moment = require('moment')

export default {
  name: 'YMDAtimeSelect',
  props: ['queryType'],
  components: {
    year,
    month,
    day,
    any,
    timeResolution
  },
  watch: {
    queryType: function () {
      this.timeType = 'month'
      this.date = [moment().startOf(this.timeType).valueOf(), moment().endOf(this.timeType).add(1, 'ms').valueOf()]
    }
  },
  data () {
    return {
      timeType: 'month',
      anyTimeResolution: 'month',
      // date: '',
      // anyData: []
      anyData: [moment().startOf('month').valueOf(), moment().endOf('month').valueOf()],
      date: [moment().startOf('month').valueOf(), moment().endOf('month').add(1, 'ms').valueOf()]
    }
  },
  methods: {
    log () {
      console.log(this.date)
    },
    reset () {
      this.date = [moment().startOf(this.timeType).valueOf(), moment().endOf(this.timeType).add(1, 'ms').valueOf()]
      this.emit()
    },
    emit () {
      this.$emit('input', [this.timeType, this.date])
    },
    emitAny () {
      this.$emit('input', [this.anyTimeResolution, this.anyData])
    }
  }
}
</script>

<style lang="scss" scoped>
.ymda-time-select-container {
  display: flex;
  align-items: center;
  .time-selects {
    width: 90px;
  }
}
</style>
